import fullQuoteTransition from '../FullQuoteTransition';
import paFlowDefnFactory from 'edge/quoteandbind/pa/config/FlowConfig';
import bopFlowDefnFactory from 'edge/quoteandbind/bop/config/FlowConfig';

var paFlowStepsRequiredForTransition = {
    contactDetailsComplete: 'paContactDetailsComplete',
    coverablesComplete: 'paCoverablesComplete',
    offeringSelected: 'offeringSelected',
    moreInfoComplete: 'paMoreInfoComplete'
};

var bopFlowStepsRequiredForTransition = {
    contactDetailsComplete: 'bopContactDetailsComplete',
    coverablesComplete: 'bopCoverablesComplete',
    offeringSelected: 'offeringSelected',
    moreInfoComplete: 'bopMoreInfoComplete'
};

function transitionToBOPFromGuidanceFlow() {
    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
    }

    fullQuoteTransition.transition.apply(fullQuoteTransition, [bopFlowDefnFactory, bopFlowStepsRequiredForTransition].concat(params));
}

function transitionToPAFromSLQFlow() {
    for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
    }

    fullQuoteTransition.transition.apply(fullQuoteTransition, [paFlowDefnFactory, paFlowStepsRequiredForTransition].concat(params));
}

export default {
    fullQuoteFlowDefn: function fullQuoteFlowDefn(submission, productCode, $q) {
        for (var _len3 = arguments.length, params = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
            params[_key3 - 3] = arguments[_key3];
        }

        if (productCode === 'PersonalAuto') {
            transitionToPAFromSLQFlow.apply(undefined, [submission, $q].concat(params));
        } else if (productCode === 'BusinessOwners') {
            transitionToBOPFromGuidanceFlow.apply(undefined, [submission, $q].concat(params));
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/config/ConditionalProductFlow.js
// module id = 1214
// module chunks = 0